<template>
  <div id="event-live-donated-item-list">
    <div class="event-live-donated--flame--donated">
      <template v-for="(item, index) in items">
        <div class="event-live-donated--section--wrap--donated--row" :class="{'event-live-donated--section--wrap--donated--row--more_10000': item.price >= 10000, 'event-live-donated--section--wrap--donated--row--more_30000': item.price >= 30000}">
          <div class="event-live-donated--section--donated--row">
            <img v-bind:src="item.avatar" class="event-live-donated--image__circle">
            <div class="event-live-donated--section--label">
              <p class="event-live-donated--label__black__little">{{fromAndToMessage(item.from_user_name, item.to_user_name)}}</p>
              <p class="event-live-donated--label__gray">{{item.donation_message}}</p>
              <p class="event-live-donated--label__no_disp__created_date" style="display: none;">{{formatDate(item.createdAt)}}</p>
              <p class="event-live-donated--label__no_disp__price" style="display: none;">{{item.price}}</p>
              <p class="event-live-donated--label__no_disp__from" style="display: none;">{{item.from_user_name}}</p>
              <p class="event-live-donated--label__no_disp__to" style="display: none;">{{item.to_user_name}}</p>
            </div>
          </div>
        </div>
      </template>
      <div class="pg-live--section--sp_only">
        <div class="pg-live--section--space"></div>
      </div>
      <div class="event-live-donated--button__donated_disp--wrap event-live-donated__only_pc" v-on:click="liveDonationDisp">
        <span class="event-live-donated--button__donated_disp--label">ギフト非表示 ∧ </span>
      </div>
    </div>
    <div class="event-live-donated--flame--non_donated event-live-donated--button__donated_disp--wrap event-live-donated__only_pc event-live-donated--button__donated_disp--label" v-on:click="liveDonationNonDisp" style="display:none; margin-top: 0; background: #FFFFFF;">
      <p>ギフト表示 ∨ </p>
    </div>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'

  export default {
    name: "EventLiveDonatedItemList",
    props: {
      ttsid: { type: String, required: true },
    },
    data: () => ({
      items: [],
      uID: "",
      isDispDonated: true,
      inputForm: {
        body: null,
      },
      contents: {
        width : 0,
        height : 0,
      }
    }),
    firestore() {
      const roomId = this.ttsid;
      // 投げ銭されたアイテムの取得
      return {
        items: db.collection(consts.EVENT_LIVE_DONATION_STSTUS.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_DONATION_STSTUS.CHILD_COLLECTTION).orderBy('createdAt', 'asc')
      }
      scrollDonatedFlameBottom()
    },
    computed: {
      consts: function() {
        return consts
      },
    },
    methods: {
      // 投げ銭の表示
      liveDonationDisp: function() {
        if (this.isDispDonated) {
          this.isDispDonated = false
          $('.event-live-donated--flame--donated').hide()
          $('.event-live-donated--flame--non_donated').show()
        } else {
          this.isDispDonated = true
        }
      },
      // 投げ銭の非表示制御
      liveDonationNonDisp: function() {
        this.isDispDonated = true
        $('.event-live-donated--flame--non_donated').hide()
        $('.event-live-donated--flame--donated').show()
        setTimeout(function(){
        }, 200);
      },
      // 表示文言
      fromAndToMessage: function(from_user_name, to_user_name) {
        var str = ""
        if (from_user_name.length > 0){
          str = from_user_name + "が"
        }
        return str + to_user_name + "を応援しました"
      },
      // 日付整形(yyyy/n/d hh:mm)
      formatDate: function(date) {
        if (date == 'undefined' || date == null || date.length > 0){
          return ""
        }
        var day = date.toDate()
        return day.getFullYear() + '/' + (day.getMonth() + 1).toString().padStart(2, '0') + '/' + day.getDate().toString().padStart(2, '0') + " " + day.getHours().toString().padStart(2, '0') + ":" + day.getMinutes().toString().padStart(2, '0')
      },
      // onLoadイベント
      window:onload = function() {
        scrollDonatedFlameBottom()
      },
    },
    watch: {
      // コメントの取得
      items: function () {
        setTimeout(function(){
          setCustomStyle('#event-live-donated-item-list')
        }, 100);
        scrollDonatedFlameBottom()
      }
    },
    mounted: function () {
      setCustomStyle('#event-live-donated-item-list')
    }
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  .event-live-donated--flame--donated {
    width: 410px;
    height: 310px;
    display: inline-block;
    position: relative;
    border: 1px solid #DCDCDC;
    overflow-y: scroll;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media screen and (max-width: 1000px) {
      width: 100vw;
      border: none;
    }
  }

  .event-live-donated--flame--donated::-webkit-scrollbar {
    display:none;
  }

  .event-live-donated--section--wrap--donated--row {
    width: 100vw;
  }

  .event-live-donated--section--wrap--donated--row--more_10000 {
    background-color: #E6FAFF;
  }

  .event-live-donated--section--wrap--donated--row--more_30000 {
    background-color: #FFE6DC;
  }

  .event-live-donated--section--donated--row {
    width: 100%;
    display: -webkit-box;
    word-break: break-all;
    padding: 8px 8px 8px 8px;

    @media screen and (max-width: 1000px) {
      width: 96vw;
      padding: 8px calc(2vw + 8px) 8px;
    }
  }

  .event-live-donated--image__circle {
    height: 50px;
    width: 50px;
    object-fit: cover;
  }

  .event-live-donated--section--label {
    display: block;
    margin-left: 5px;
    max-width: 340px;
    line-height: 1;

    @media screen and (max-width: 1000px) {
      max-width: 78vw;
    }
  }

  .event-live-donated--label__black__little{
    font-size: 10px;
    color: #999999;
  }

  .event-live-donated--label__gray {
    font-size: 13px;
    margin-top: 5px;
    color: #666666;
  }

  .event-live-donated--button__donated_disp--wrap{
    color: #666666;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 11.5px;
  }

  .event-live-donated__only_pc {

    @media screen and (max-width: 1000px) {
      display: none;
    }
  }

  .event-live-donated--flame--non_donated {
    border: 1px solid #DCDCDC;
    height: 62px;
    padding-left: 8px;
    background: #FAFAFA;
    border: 1px solid #DCDCDC;
    padding-top: 20px;
  }

  .event-live-donated--button__donated_disp--wrap{
    color: #666666;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 11.5px;
  }

  .event-live-donated--button__donated_disp--label {
    width: 410px;
    cursor: pointer;
  }

</style>
